<div
  #fieldRoot
  class="flex flex-col gap-1.5 scroll-mb-3"
  [class]="containerClass()">
  <label
    class="checklist-task-label label"
    [class.sr-only]="hideLabel()"
    [attr.for]="id()">
    {{ labelText() }}
  </label>

  @if (isReadonly) {
    <div class="flex items-center gap-2">
      <output
        class="text-sm font-normal text-primary leading-6"
        [attr.id]="id()"
        role="note">
        {{ displayText }}
      </output>
      @if (suffixText() && text.length > 0) {
        <span class="text-sm font-normal text-secondary leading-6">
          {{ suffixText() }}
        </span>
      }
    </div>
  } @else {
    <div class="flex items-center gap-2">
      <div class="relative flex-1 min-w-0">
        <input
          #inputEl
          [id]="id()"
          class="checklist-input w-full"
          [class.pr-10]="!hasTrailingContent"
          [class.pr-16]="hasTrailingContent"
          [attr.type]="'text'"
          [attr.placeholder]="placeholder() || null"
          [attr.inputmode]="isMobilePortrait() ? 'none' : 'decimal'"
          [readOnly]="state().readonly()"
          [value]="editText()"
          (input)="onInput($event)"
          (focus)="onInputFocus()"
          (blur)="onInputBlur()" />
        @if (state().touched() && state().errors().length > 0) {
          <div
            class="absolute inset-y-0 right-3 flex items-center pointer-events-none">
            <svg-icon
              src="/assets/svg/alert-circle.svg"
              class="w-5 h-5 text-error-primary"
              svgClass="w-5 h-5" />
          </div>
        }
      </div>
      @if (suffixText()) {
        <span class="text-sm font-normal text-secondary whitespace-nowrap">
          {{ suffixText() }}
        </span>
      }
    </div>
    @if (state().touched() && state().errors().length > 0) {
      <p class="text-error-primary m-0 p-0">{{ errorMessage }}</p>
    }
  }
</div>
